import { z } from 'zod';
import { HouseholdId, IsoDatetime, NotificationId, UserId } from './primitives.js';

export const NotificationKind = z.enum([
  'operation_new',
  'operation_reminder',
  'operation_overdue',
  'operation_escalated',
  'operation_read',
  'proof_uploaded',
  'approval_needed',
  'approval_granted',
  'approval_rejected',
  'receipt_uploaded',
  'cash_request',
  'system',
]);
export type NotificationKind = z.infer<typeof NotificationKind>;

export const Notification = z.object({
  id: NotificationId,
  household_id: HouseholdId,
  user_id: UserId,
  kind: NotificationKind,
  title: z.string().min(1).max(200),
  body: z.string().min(1).max(500),
  payload: z.record(z.unknown()),
  read_at: IsoDatetime.nullable(),
  delivered_at: IsoDatetime.nullable(),
  failed_reason: z.string().nullable(),
  created_at: IsoDatetime,
});

export const NotificationPrefs = z.object({
  push_per_kind: z.record(NotificationKind, z.boolean()).default({}),
  quiet_hours: z
    .object({
      start: z.string().regex(/^\d{2}:\d{2}$/),
      end: z.string().regex(/^\d{2}:\d{2}$/),
      days: z.array(z.number().int().min(0).max(6)),
    })
    .nullable(),
});
export type NotificationPrefs = z.infer<typeof NotificationPrefs>;
